import axios from 'axios';

export const aiProviderSetting = {
    namespaced: true,
    state: {
        providers: [],
    },
    getters: {
        providers: function (state) {
            return state.providers;
        },
    },
    actions: {
        providerSettings: function (context) {
            return new Promise((resolve, reject) => {
                axios.get('admin/setting/ai-provider').then((res) => {
                    context.commit('providers', res.data.data);
                    resolve(res);
                }).catch((err) => {
                    reject(err);
                });
            });
        },
        importSettings: function (context) {
            return context.dispatch('providerSettings');
        },
        saveProviderSettings: function (context, payload) {
            return new Promise((resolve, reject) => {
                axios.put('admin/setting/ai-provider', payload).then((res) => {
                    context.commit('providers', res.data.data);
                    resolve(res);
                }).catch((err) => {
                    reject(err);
                });
            });
        },
    },
    mutations: {
        providers: function (state, payload) {
            state.providers = payload;
        },
    },
};
